// Fixed wishlist functionality with localStorage
var Wishlist = (function() {
  'use strict';
  
  // Key for storing wishlist in localStorage
  var STORAGE_KEY = 'outerbloom_wishlist';
  
  // Returns the current wishlist as an array of product IDs
  function getWishlist() {
    var wishlist;
    try {
      wishlist = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      console.log('Retrieved wishlist:', wishlist);
    } catch (e) {
      console.error('Error retrieving wishlist from localStorage', e);
      wishlist = [];
    }
    return wishlist;
  }
  
  // Saves the wishlist to localStorage
  function saveWishlist(wishlist) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
      console.log('Saved wishlist:', wishlist);
    } catch (e) {
      console.error('Error saving wishlist to localStorage', e);
    }
  }
  
  // Check if a product is in the wishlist
  function isInWishlist(productId) {
    var wishlist = getWishlist();
    return wishlist.indexOf(productId.toString()) !== -1;
  }
  
  // Add a product to the wishlist
  function addToWishlist(productId) {
    var wishlist = getWishlist();
    if (!isInWishlist(productId)) {
      wishlist.push(productId.toString());
      saveWishlist(wishlist);
    }
    return wishlist;
  }
  
  // Remove a product from the wishlist
  function removeFromWishlist(productId) {
    var wishlist = getWishlist();
    var index = wishlist.indexOf(productId.toString());
    if (index !== -1) {
      wishlist.splice(index, 1);
      saveWishlist(wishlist);
    }
    return wishlist;
  }
  
  // Toggle a product in the wishlist (add if not present, remove if present)
  function toggleWishlistItem(productId) {
    console.log('Toggling product in wishlist:', productId);
    if (isInWishlist(productId)) {
      console.log('Product was in wishlist, removing:', productId);
      return removeFromWishlist(productId);
    } else {
      console.log('Product not in wishlist, adding:', productId);
      return addToWishlist(productId);
    }
  }
  
  // Update wishlist count in header
  function updateWishlistCount() {
    var wishlist = getWishlist();
    var count = wishlist.length;
    
    // Update count display
    var $badge = $('.wishlist-count');
    if (count > 0) {
      $badge.text(count).show();
      $badge.removeClass('d-none');
    } else {
      $badge.hide();
      $badge.addClass('d-none');
    }
  }
  
  // Initialize wishlist functionality
  function init() {
    updateWishlistCount();
    
    // Set initial state for wishlist buttons
    $('.wishlist-toggle').each(function() {
      var productId = $(this).data('product-handle');
      if (isInWishlist(productId)) {
        $(this).addClass('active');
      }
    });
  }
  
  // Public API
  return {
    init: init,
    isInWishlist: isInWishlist,
    getWishlist: getWishlist,
    toggleWishlistItem: toggleWishlistItem,
    addToWishlist: addToWishlist,
    removeFromWishlist: removeFromWishlist,
    updateWishlistCount: updateWishlistCount
  };
})();

// Event handlers
$(document).ready(function() {
  
  // Initialize wishlist
  Wishlist.init();
  
  // Bind event to wishlist toggles
  $(document).on('click', '.wishlist-toggle', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    var $this = $(this);
    var productId = $this.data('product-handle');
    
    Wishlist.toggleWishlistItem(productId);
    
    // Update UI
    if (Wishlist.isInWishlist(productId)) {
      $this.addClass('active');
    } else {
      $this.removeClass('active');
    }
    
    Wishlist.updateWishlistCount();
    
    return false;
  });
  
  // Handle remove from wishlist on wishlist page
  $(document).on('click', '.remove-from-wishlist', function(e) {
    e.preventDefault();
    
    var productId = $(this).data('product-id');
    Wishlist.removeFromWishlist(productId);
    
    // Remove item from UI
    $('.wishlist-item[data-product-id="' + productId + '"]').fadeOut(function() {
      $(this).remove();
      
      // Show empty state if no items left
      if ($('.wishlist-item:visible').length === 0) {
        $('#empty-wishlist').fadeIn();
      }
    });
    
    Wishlist.updateWishlistCount();
  });
});
